'use client';
import Image from 'next/image';
import Link from 'next/link';
import NewSpeakerSection from './newSpeakersSection';

const upcomingEvents = [
  // {
  //   name: "riyadh-luma",
  //   src: "/images/riyadh-luma.webp",
  //   width: 340,
  //   height: 240,
  //   link: "https://luma.com/thecapitalcircleriyadh",
  // },
  {
    name: "the-capital-circle-singapore-2026",
    src: "/images/the-capital-circle-singapore-2026.webp",
    width: 340,
    height: 240,
    link: "https://luma.com/ls6zfnmw",
  },
  {
    name: "the-capital-circle-abu-dhabi",
    src: "/images/the-capital-circle-abu-dhabi-2028.webp",
    width: 340,
    height: 240,
    link: "https://luma.com/thecapitalcircle_?k=c",
  },
];

const pastEvents = [
  {
    name: "abu-dhabi-11th_dec2025",
    src: "/images/abu-dhabi-11th_dec2025.webp",
    width: 340,
    height: 240,
    link: "https://luma.com/thecapitalcircleabudhabi",
  },
  {
    name: "singapore-event-capital-circle",
    src: "/images/singapore-event.webp",
    width: 340,
    height: 240,
    link: "https://luma.com/p9905tv6",
  },
  {
    name: "vc-node-nights",
    src: "/images/vc-node-nights.webp",
    width: 340,
    height: 240,
    link: "https://luma.com/thecapitalcircle_?k=c",
  },
  
  
];

const UpcomingEvents = () => {
  return (
    <section data-component-id="src/app/UpcomingEvents.tsx:58:4" data-component-path="src/app/UpcomingEvents.tsx" data-component-line="58" data-component-end-line="138" data-component-file="UpcomingEvents.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22events%22%2C%22className%22%3A%22w-full%20px-4%20py-12%20flex%20flex-col%20items-center%20justify-center%20bg-gradient-to-br%20from-%5B%230a2c13%5D%20to-%5B%23000000%5D%22%7D"
      id="events"
      className="w-full px-4 py-12 flex flex-col items-center justify-center bg-gradient-to-br from-[#0a2c13] to-[#000000]">
      {/* Title */}
      <h2 data-component-id="src/app/UpcomingEvents.tsx:62:6" data-component-path="src/app/UpcomingEvents.tsx" data-component-line="62" data-component-end-line="64" data-component-file="UpcomingEvents.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-center%20text-%5B24px%5D%20sm%3Atext-%5B28px%5D%20lg%3Atext-%5B32px%5D%20font-semibold%20mb-8%20bg-%5Blinear-gradient(1deg%2C%2317c64f_0%25%2C%2310b981_50%25%2C%23005529_100%25)%5D%20bg-clip-text%20text-transparent%22%2C%22textContent%22%3A%22Upcoming%20Events%22%7D" className="text-center text-[24px] sm:text-[28px] lg:text-[32px] font-semibold mb-8 bg-[linear-gradient(1deg,#17c64f_0%,#10b981_50%,#005529_100%)] bg-clip-text text-transparent">
        Upcoming Events
      </h2>

      {/* Upcoming Grid */}
      {/* <div className="grid grid-cols-2 md:grid-cols-3 gap-6 max-w-[1200px] w-full px-4 place-items-center"> */}
        <div data-component-id="src/app/UpcomingEvents.tsx:68:8" data-component-path="src/app/UpcomingEvents.tsx" data-component-line="68" data-component-end-line="86" data-component-file="UpcomingEvents.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-row%20items-center%20gap-6%22%7D" className="flex flex-row items-center gap-6">

        {upcomingEvents.map((event, index) => (
          <Link data-component-id="src/app/UpcomingEvents.tsx:71:10" data-component-path="src/app/UpcomingEvents.tsx" data-component-line="71" data-component-end-line="84" data-component-file="UpcomingEvents.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%7D"
            key={index}
            href={event.link}
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            <Image data-component-id="src/app/UpcomingEvents.tsx:77:12" data-component-path="src/app/UpcomingEvents.tsx" data-component-line="77" data-component-end-line="83" data-component-file="UpcomingEvents.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%7D"
              src={event.src}
              alt={event.name}
              width={event.width}
              unoptimized
              height={event.height}
            />
          </Link>
        ))}
      </div>

      {/* Buttons Row */}
      <div data-component-id="src/app/UpcomingEvents.tsx:89:6" data-component-path="src/app/UpcomingEvents.tsx" data-component-line="89" data-component-end-line="107" data-component-file="UpcomingEvents.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mt-10%20flex%20flex-col%20sm%3Aflex-row%20gap-4%20w-full%20sm%3Aw-auto%22%7D" className="mt-10 flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
        <a data-component-id="src/app/UpcomingEvents.tsx:90:8" data-component-path="src/app/UpcomingEvents.tsx" data-component-line="90" data-component-end-line="97" data-component-file="UpcomingEvents.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22href%22%3A%22https%3A%2F%2Flu.ma%2Fthecapitalcircle_%3Fk%3Dc%22%2C%22className%22%3A%22capitalize%20px-8%20py-3%20bg-%5B%2320c940%5D%20text-black%20font-semibold%20rounded-full%20hover%3Abg-%5B%231bb232%5D%20transition-colors%20text-center%22%2C%22textContent%22%3A%22Register%20here%22%7D"
          href="https://lu.ma/thecapitalcircle_?k=c"
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="capitalize px-8 py-3 bg-[#20c940] text-black font-semibold rounded-full hover:bg-[#1bb232] transition-colors text-center"
        >
          Register here
        </a>

        <a data-component-id="src/app/UpcomingEvents.tsx:99:8" data-component-path="src/app/UpcomingEvents.tsx" data-component-line="99" data-component-end-line="106" data-component-file="UpcomingEvents.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22href%22%3A%22%2Fcontact%2F%22%2C%22className%22%3A%22capitalize%20px-8%20py-3%20bg-%5B%2320c940%5D%20text-black%20font-semibold%20rounded-full%20hover%3Abg-%5B%231bb232%5D%20transition-colors%20text-center%22%2C%22textContent%22%3A%22Apply%20to%20partner%22%7D"
          href="/contact/"
          target="_blank"
          rel="noopener noreferrer"
          className="capitalize px-8 py-3 bg-[#20c940] text-black font-semibold rounded-full hover:bg-[#1bb232] transition-colors text-center"
        >
          Apply to partner
        </a>
      </div>


      {/* new speakers */}
      {/* <NewSpeakerSection /> */}

      {/* Past Events Title */}
      <h2 data-component-id="src/app/UpcomingEvents.tsx:114:6" data-component-path="src/app/UpcomingEvents.tsx" data-component-line="114" data-component-end-line="116" data-component-file="UpcomingEvents.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-center%20text-%5B24px%5D%20sm%3Atext-%5B28px%5D%20lg%3Atext-%5B32px%5D%20font-semibold%20mb-8%20mt-10%20bg-%5Blinear-gradient(1deg%2C%2317c64f_0%25%2C%2310b981_50%25%2C%23005529_100%25)%5D%20bg-clip-text%20text-transparent%22%2C%22textContent%22%3A%22Past%20Events%22%7D" className="text-center text-[24px] sm:text-[28px] lg:text-[32px] font-semibold mb-8 mt-10 bg-[linear-gradient(1deg,#17c64f_0%,#10b981_50%,#005529_100%)] bg-clip-text text-transparent">
        Past Events
      </h2>

      {/* Past Events Grid */}
      <div data-component-id="src/app/UpcomingEvents.tsx:119:6" data-component-path="src/app/UpcomingEvents.tsx" data-component-line="119" data-component-end-line="136" data-component-file="UpcomingEvents.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20md%3Agrid-cols-3%20gap-6%20max-w-%5B1200px%5D%20w-full%20px-4%20place-items-center%20justify-center%22%7D" className="grid grid-cols-2 md:grid-cols-3 gap-6 max-w-[1200px] w-full px-4 place-items-center justify-center">
        {pastEvents.map((event, index) => (
          <Link data-component-id="src/app/UpcomingEvents.tsx:121:10" data-component-path="src/app/UpcomingEvents.tsx" data-component-line="121" data-component-end-line="134" data-component-file="UpcomingEvents.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%7D"
            key={index}
            href={event.link}
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            <Image data-component-id="src/app/UpcomingEvents.tsx:127:12" data-component-path="src/app/UpcomingEvents.tsx" data-component-line="127" data-component-end-line="133" data-component-file="UpcomingEvents.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%7D"
              src={event.src}
              alt={event.name}
              width={event.width}
              unoptimized
              height={event.height}
            />
          </Link>
        ))}
      </div>

    </section>
  );
};

export default UpcomingEvents;
